// src/utils/orderUtils.js
import ProductionStatusService from "@/services/ProductionStatusService";

export const barcodePatterns = {
  'garment'       : /^G(\d+)$/,
  'customer'      : /^C(\d+)$/,
  'item'          : /^I(\d+)$/,
  'order'         : /^O(\d{3,})$/,
  'order-id'      : /^(\d{3,})$/,
  'ticket'        : /^ST(\d{9,})\/(\w{8,})$/, // Valid for types 2: ST000787166/ecc3d838
  'ticket_order'  : /^ST(\d{9,})\/(\d{2})$/, // Valid for types 1: ST000787163/03
  'rail'          : /^R(\d{4})$/,             // Dispatch Rails, in the loading bay
  'qc-status'     : /^QCS(\d{1,})$/,
  'qc-rail'       : /^QCR(\d{1,})$/,
  'pu-rail'       : /^PUR(\d{4})$/,
  'command'       : /^LRCMD:(.*)$/,
  'rfid-hex'      : /^([0-9A-Fa-f]{24})$/
};
export const requiresAssemblyChecks = (service_ids, servicesWithoutPiecingUp) => {
    for (let service_id of service_ids) {
        if (servicesWithoutPiecingUp.includes(service_id))
            return false
    }
    return true
};
export const itemAlreadyAssembled = ( orderitem, serviceticket, aliases, servicesWithoutPiecingUp ) => {
    if( !aliases.assembled)
        return false;

    if( !requiresAssemblyChecks(serviceticket.service_ids.map(id => parseInt(id)),servicesWithoutPiecingUp) )
        return ! ProductionStatusService.afterOrEqualTo( aliases.assembled, orderitem.itemstatustype_id );

    return ProductionStatusService.afterOrEqualTo( aliases.assembled, orderitem.itemstatustype_id );

};
export const itemAlreadyOnVan = ( orderitem, serviceticket, aliases, servicesWithoutPiecingUp ) => {
    if( !aliases.onVan )
        return false;

    if( !requiresAssemblyChecks(serviceticket.service_ids.map(id => parseInt(id)),servicesWithoutPiecingUp) )
        return ! ProductionStatusService.afterOrEqualTo( aliases.onVan, orderitem.itemstatustype_id );

    return ProductionStatusService.afterOrEqualTo( aliases.onVan, orderitem.itemstatustype_id );

};
export const itemIsReady = (orderitem, aliases ) => {
    if( !aliases)
        return false;
    return ProductionStatusService.equalTo( aliases.processed,  orderitem.itemstatustype_id )
        || ProductionStatusService.equalTo( aliases.atSupplier,  orderitem.itemstatustype_id );

};
export const itemCanBeAssembled = async ( orderitem, serviceticket, aliases, servicesWithoutPiecingUp) => {
    return new Promise((resolve) => {
        console.log(aliases.value);
        if( !aliases.value)
            resolve(false);

        console.log("requiresAssemblyChecks");
        if( !requiresAssemblyChecks(serviceticket.service_ids.map(id => parseInt(id)),servicesWithoutPiecingUp) )
            resolve (! ProductionStatusService.afterOrEqualTo( aliases.value.assembled, orderitem.itemstatustype_id ));

        console.log("async piecedUp", aliases.value.piecedUp + ' = ' + orderitem.itemstatustype_id);
        console.log("async assembled", aliases.value.assembled + ' = ' + orderitem.itemstatustype_id);

        resolve (ProductionStatusService.afterOrEqualTo( aliases.value.piecedUp,  orderitem.itemstatustype_id )
            && ! ProductionStatusService.afterOrEqualTo( aliases.value.assembled, orderitem.itemstatustype_id ));
    });
};
export const itemCanBeAssembledOLD = ( orderitem, serviceticket, aliases, servicesWithoutPiecingUp ) => {
    if( !aliases.assembled && !aliases.piecedUp)
        return false;

    console.log("requiresAssemblyChecks");
    if( !requiresAssemblyChecks(serviceticket.service_ids.map(id => parseInt(id)),servicesWithoutPiecingUp) )
        return ! ProductionStatusService.afterOrEqualTo( aliases.assembled, orderitem.itemstatustype_id );

    console.log("piecedUp", aliases.piecedUp + ' = ' + orderitem.itemstatustype_id);
    console.log("assembled", aliases.assembled + ' = ' + orderitem.itemstatustype_id);
    return ProductionStatusService.afterOrEqualTo( aliases.piecedUp,  orderitem.itemstatustype_id )
        && ! ProductionStatusService.afterOrEqualTo( aliases.assembled, orderitem.itemstatustype_id );

};
export const getOrderItemClass = (orderItem, item, aliases, servicesWithoutPiecingUp) => {
    if (itemIsReady(orderItem, aliases)) {
        return 'flagged';
    }
    if (itemCanBeAssembled(orderItem, item, aliases, servicesWithoutPiecingUp)) {
        return 'selected';
    }
    return 'disabled';
};

export const getOrderItemIcon = (orderItem, item, aliases, servicesWithoutPiecingUp) => {
    if (itemIsReady(orderItem, aliases)) {
        return 'fas fa-exclamation-circle';
    }
    if (itemCanBeAssembled(orderItem, item, aliases, servicesWithoutPiecingUp)) {
        return 'fas fa-check-circle';
    }
    return 'fas fa-times-circle';
};

export const getOrderItemStatus = (orderItem, aliases) => {
    for (let status in aliases) {
        if (aliases[status] == orderItem.itemstatustype_id) {
            return status;
        }
    }
    return '';
};

export const getBarcodeDetails = (barcode, barcodePatterns) => {
    let barcode_type;
    let barcode_id;
    for (let type in barcodePatterns) {
        let matchResult = barcode.match(barcodePatterns[type]);
        if (matchResult) {
            barcode_type = type;
            barcode_id = matchResult[1] || barcode;
            break;
        }
    }
    return { type: barcode_type, id: barcode_id, barcode: barcode };
};

export const getBlueBagNoticeClass = (order) => {
    if( ! order.orderid )
        return '';
    if( order.first_order )
        return 'first-order';
    if( ! order.blue_bag )
        return 'no-bag';
    return '';
};
export const getBlueBagNotice = (order) =>{
    if( ! order.orderid )
        return null;
    if( order.first_order )
        return 'Customer is placing their first order, use a new blue bag.';
    if( ! order.blue_bag )
        return 'Customer did NOT use a Blue Bag.';
    return null;
};